import { atom } from 'jotai';
import { createPaginatedRequestAtom, createRequestAtom } from '../../../shared/utils/request-atom';
import {
  ACTION_TYPES,
  cxOverview,
  CxOverviewMetricsAPIResponseType,
  CxOverviewMetricsType,
  cxOverviewPaginationData,
} from '../typings';
import { CxOverviewFilters } from '../molecules/Filters/constants';

export const cxOverviewAtom = createPaginatedRequestAtom<cxOverview, cxOverviewPaginationData>({
  loading: false,
});

export const cxOverviewMetricsAtom = atom<CxOverviewMetricsAPIResponseType>({
  perState: {},
  totalIncidents: 0,
  isLoading: true,
});

export const isCxIssueEnabledAtom = createRequestAtom<{ enabled: boolean }>();

export const defaultCxOverviewFilters: CxOverviewFilters = {
  agents: ['all'],
  issues: ['all'],
  status: ['all'],
  dateRange: null,
  customDateRange: undefined,
  startDate: null,
  endDate: null,
};
export const cxOverviewFiltersAtom = atom<CxOverviewFilters>(defaultCxOverviewFilters);

export const isFiltersEditedEverAtom = atom<boolean>(false); // to track if filter is ever changed ( will be true if filter change => filter reset => filter change in all 3 contion)

export const selectedStatusFilterFromCardClickAtom = atom<ACTION_TYPES | null>(null);
